import Image from 'next/image';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('business');

/** Copy defaults to the /business landing page's. */
const BusinessHero = ({
  badge,
  title,
  description,
}: {
  badge?: string;
  title?: string;
  description?: string;
} = {}) => {
  const leftSectionDesktop = getEdgeUrl('images/business/left-section-b2b.png');
  const rightSectionDesktop = getEdgeUrl(
    'images/business/right-section-b2b.png',
  );

  return (
    <div className="relative flex w-screen flex-col justify-center overflow-hidden bg-[linear-gradient(1deg,_#E9F8F9_7.84%,_var(--Teel-Light,_#E9F8F9)_7.92%,_var(--Aqua,_#92F7FA)_104.84%)] py-5 text-gray-700 md:h-[280px] md:items-center md:py-0">
      {/* Left Block Desktop  */}
      <div className="absolute bottom-0 hidden md:left-[-170px] md:block lg:left-[-60px] xl:left-0">
        <div className="h-[280px]">
          <Image
            src={leftSectionDesktop}
            alt={t`Left Section`}
            loading="eager"
            height={800}
            width={800}
            className="h-full w-auto"
            priority
          />
        </div>
      </div>
      {/* Right Block Desktop/Mobile */}
      <div className="absolute bottom-0 right-[-80px] h-full opacity-20 xxs:opacity-100 md:right-[-150px] lg:right-[-60px] xl:right-0">
        <div className="h-full md:h-[280px]">
          <Image
            src={rightSectionDesktop}
            alt={t`Right Section`}
            loading="eager"
            height={800}
            width={800}
            className="h-full w-auto"
            priority
          />
        </div>
      </div>
      <div className="relative">
        <div className="reebelo-container">
          <div className="flex w-full flex-col text-center xxs:max-w-[calc(100%-110px)] xxs:text-left md:max-w-full md:items-center md:justify-center md:text-center">
            {badge && (
              <span className="mb-2 inline-flex self-center rounded-full bg-[#D6FFE2] px-2.5 py-0.5 text-xxs font-medium text-[#128452] xxs:self-start md:self-center">
                {badge}
              </span>
            )}
            <h1 className="max-w-[350px] text-lg font-bold leading-6 sm:!leading-7 md:text-2xl xl:max-w-[460px] xl:text-3xl xl:!leading-8">
              {title ?? t`Quality tech for your business, for less.`}
            </h1>
            <p className="mt-2 max-w-[450px] text-sm !leading-snug md:text-base xl:max-w-[500px]">
              {description ??
                t`Refurbished laptops, phones, and tablets at volume pricing backed by a 12-month warranty and a dedicated account manager.`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessHero;
